import axiosInstance from "../lib/axiosInstance";

class productsModel {
  constructor() {
    this.base_url = "/products";
    this.base_url2 = "/product";
    this.base_url3 = "/vendor-export-product";
  }
  async list(query = []) {
    return (
      await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)
    ).data;
  }
  async create(data = []) {
    return await axiosInstance.post(this.base_url, data);
  }
  async update(id, data = []) {
    return await axiosInstance.post(`${this.base_url}/${id}?_method=PUT`, data);
  }
  async destroy(id, data = []) {
    return await axiosInstance.delete(`${this.base_url}/${id}`, data);
  }
  async bulkDestroy(data = []) {
    return await axiosInstance.post(`${this.base_url}/bulk_delete`, data);
  }
  async show(id) {
    return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
  }
  async bulkupdate(id, data = []) {
    return await axiosInstance.post(`/product/${id}/import?_method=PUT`, data);
  }
  async bulkupload(id, data = []) {
    return await axiosInstance.post(`/product/${id}/import`, data);
  }
  async inventory(id) {
    return (await axiosInstance.get(`/inventory/${id}`)).data;
  }
  async manageInventory(data = [], id) {
    return await axiosInstance.post(`${this.base_url}/${id}/inventory?`, data);
  }
  async updateInventory(data = []) {
    return await axiosInstance.post(`${this.base_url2}/quantity_update`, data);
  }
  async ExportProduct(data = []) {
        return await axiosInstance.post(`${this.base_url3}`, data);
    }
}

export default new productsModel();
